<template>
  <div class="newWeixinLogin">
    <div class="code-img">
      <img :class="[{'code_beOverdue': beOverdue}]" :src="qr.qrcodeUrl" alt="">
      <div class="beOverdue" v-if="beOverdue">
        <p>二维码已失效</p>
        <div>
          点击
          <el-button icon="el-icon-refresh-right" type="text">刷新</el-button>
        </div>
      </div>
    </div>
    <p class="tips">扫码关注公众号&nbsp;即可注册/登录</p>
  </div>
</template>

<script>
  import { getWechatQrcode, wechatPolling } from "../../../api/accountManage";

  export default {
    data() {
      return {
        qr: {},
        timer: null,
        num: 0,
        beOverdue: false,
        polling: false
      }
    },
    beforeDestroy() {
      this.stop();
      // window.removeEventListener("message", this.receiveMessage, false);
    },
    mounted () {
      this.getCode();
      // window.addEventListener("message", this.receiveMessage, false);
    },
    destroyed() {
      //离开页面销毁
      this.stop();
    },
    methods: {
      // 监听外部页面传入信息
      receiveMessage(e) {
        if (e.data?.type == "polling") {
          this.polling = true;
        }
      },
      getCode() {
        // 如果是iframe(即URL地址携带参数‘clientType’)且polling为true,请求二维码接口
        // if (this.$route.query?.clientType && !this.polling) return;
        // 彩虹网不请求
        if (this.$route.query?.clientType && this.$route.query?.clientType === "CAIHONG") return;
        this.num = 0;
        getWechatQrcode().then(res => {
          if (res.code === 1) {
            this.qr = res.data;
            this.pollingFun();
          }
        });
      },
      async pollingFun() {
        let res = await wechatPolling({
          qrcodeToken: this.qr.qrToken, // 二维码轮询key
          deviceType: 1, // 1pc,2h5,3app,4小程序，5未知设备
          clientType: 1 // 1SAAS 2IYW 3CAIHONG 4TUAN 5PORTAL
        }).catch(() => {
          this.stop();
        });
        if (res && res.code === 1) {
          if (res.data.token) { // 当token有值时，直接登录。
            this.$emit("setUserLoginInfo", res.data);
            this.stop();
            return;
          } else if (res.data.wechatKey) { // 当wechatKey有值时代表用户扫码成功，已经获取到用户的微信信息，可以跳转做绑定注册登录。
            this.$emit("BindingPhone", res.data.wechatKey);
            this.stop();
            return;
          }
          if (this.num === -1) return;
          this.timer = setTimeout(() => {
            this.pollingFun();
          }, 1000); // 轮询
        }
      },
      stop() { // 停止
        this.num = -1;
        clearTimeout(this.timer);
        this.timer = null;
      },

      setStatus() {
        this.$emit("setStatus", 4);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .newWeixinLogin {
    margin: 62px 0 64px;
    img {
      width: 100%;
      height: auto;
    }
    .code-img {
      width: 162px;
      height: 162px;
      margin: 0 auto;
      position: relative;
      .code_beOverdue {
        filter: blur(3px);
      }
      .beOverdue {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: #FFF, $alpha: 0.9);
        text-align: center;
        padding-top: 54px;
        font-size: 14px;
      }
    }
    .tips {
      font-size: 16px;
      font-weight: 400;
      color: #657097;
      line-height: 22px;
      text-align: center;
      margin-top: 20px;
    }
  }
</style>